import(/* webpackMode: "eager", webpackExports: ["NotFoundFallback"] */ "/opt/app/src/rsc/pages/NotFoundFallback.client.tsx");
